import React from 'react';
import { PROCESS_STEPS } from '../data/content';
import { Overline } from './Overline';
export function ProcessSection() {
  return <section id="proceso" className="bg-sand py-24 lg:py-32" data-id="element-318" data-mp="yzfj9y9p6jt5">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-319" data-mp="u1e07dc9ukho">
        <div className="max-w-2xl" data-id="element-320" data-mp="u409bhet9820">
          <Overline data-id="element-321" data-mp="p3cfknz76d43">Proceso</Overline>
          <h2 className="mt-6 font-serif text-[2.1rem] font-light leading-[1.1] text-ink sm:text-[2.8rem]" data-id="element-322" data-mp="p4du52ff9hqk">
            Así conseguimos que tu suelo quede bien desde el primer día
          </h2>
        </div>

        <ol className="mt-16 border-t border-ink/10" data-id="element-323" data-mp="1hs9xgpzhy7wb">
          {PROCESS_STEPS.map((step, i) => <li key={step.title} className="group grid gap-3 border-b border-ink/10 py-8 transition-colors duration-200 ease-premium hover:bg-cream/60 sm:grid-cols-12 sm:gap-8 sm:px-2" data-id="element-324" data-mp="1cyymqdrkd6z4" data-mpi={i}>
              <span className="font-serif text-xl text-walnut sm:col-span-1" data-id="element-325" data-mp="20qcjqx0ntqqf">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3 className="font-serif text-[1.55rem] font-light leading-snug text-ink sm:col-span-5" data-id="element-326" data-mp="263pcdbdlmh49">
                {step.title}
              </h3>
              <p className="text-[13.5px] leading-relaxed text-stone-600 sm:col-span-6" data-id="element-327" data-mp="1wcl22oyvbkfr">
                {step.text}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}